import { Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { GlobalService } from "app/global/global.service";
import { Checkboxfield } from "app/interfaces/checkboxfield";
import { DatepickerField } from "app/interfaces/datepickerfield";
import { DroplistField } from "app/interfaces/droplistfields";
import { FieldInfo } from "app/interfaces/field-base";
import { DroplistOptions, Field } from "app/interfaces/fields";
import { MultichoiceField } from "app/interfaces/multichoicefield";
import { Signaturefield } from "app/interfaces/signaturefield";
import { Textfield } from "app/interfaces/textfield";
import { contentFields } from "../content-fields/contentFields";
import { UUID } from "./uuid-generator";
declare const $;


export interface IDefaultDroplistOption extends DroplistOptions { }

export interface ICommonOptions extends Field {
    type_of: string,
    uuid: string,
    field_info: FieldInfo,
    column: string,
    field_block: number,
    field_required: string,
    options?: DroplistOptions[]
}


@Injectable({
    providedIn: 'root'
})

export class FieldsBuilderService {
    public options = [
        {
            name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 1",
            id: UUID(),
            value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 1",
            meta_data_id: 0
        },
        {
            name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 2",
            id: UUID(),
            value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 2",
            meta_data_id: 0
        }
    ];

    constructor(
        private _globalService: GlobalService,
        private _translocoService: TranslocoService,
        public _contentFieldService: contentFields
    ) { }



    /**
     * Returns common properties for form fields.
     * @returns An object containing common properties for form fields.
     */
    getCommonProps(uuid: string, extraKeys = {}): ICommonOptions {
        return {
            type_of: 'field',
            uuid: uuid,
            field_info: FieldInfo.DOCUMENT_FIELD,
            column: "100",
            field_block: 1,
            field_required: "1",
            ...extraKeys
        };
    }




    /**
     * Extracts the field object based on the common properties.
     * This method is used to create a field object for different types of fields.
     * @param commonProps - Common properties for the field.
     * @returns The field object based on the type of field.
     */
    extractDroplistFieldObject(commonProps: ICommonOptions) {
        return DroplistField.tag(commonProps);
    }


    /**
     * Extracts the field object based on the common properties.
     * This method is used to create a field object for different types of fields.
     * @param commonProps - Common properties for the field.
     * @returns The field object based on the type of field.
     */
    extractMultiChoiceFieldObject(commonProps: ICommonOptions) {
        return MultichoiceField.tag(commonProps);
    }


    /**
     * Extracts the text field object based on the common properties.
     * This method is used to create a text field object.
     * @param commonProps - Common properties for the text field.
     * @returns The text field object.
     */
    extractTextFieldObject(commonProps: ICommonOptions) {
        return Textfield.tag(commonProps);
    }


    /**
     * Extracts the date picker field object based on the common properties.
     * This method is used to create a date picker field object.
     * @param commonProps - Common properties for the date picker field.
     * @returns The date picker field object.
     */
    extractDatePickerFieldObject(commonProps: ICommonOptions) {
        return DatepickerField.tag(commonProps);
    }




    /**
     * Extracts the checkbox field object based on the common properties.
     * This method is used to create a checkbox field object.
     * @param commonProps - Common properties for the checkbox field.
     * @returns The checkbox field object.
     */
    extractCheckboxFieldObject(commonProps: ICommonOptions) {
        return Checkboxfield.tag(commonProps);
    }



    /**
     * Extracts the signature field object based on the common properties.
     * This method is used to create a signature field object.
     * @param commonProps - Common properties for the signature field.
     * @returns The signature field object.
     */
    private extractSignatureFieldObject(commonProps: ICommonOptions) {
        return Signaturefield.tag({
            ...commonProps,
            select_type_text: "Signature",
            value: this._globalService.user_settings.signature
        });
    }




    /**
     * Initializes the sort on image box.
     * @param element 
     */
    initSortOnImage(element) {
        $(element).sortable({
            axis: 'x',
            cancel: '.cke_editable, .cke-editor-box'
        })
    }
}